var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#343330",
    stroke: "#303030",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CaretDown"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0887 13.839L10.0885 13.8392C10.0769 13.8508 10.0631 13.86 10.048 13.8663C10.0328 13.8726 10.0165 13.8758 10.0001 13.8758C9.98367 13.8758 9.96741 13.8726 9.95224 13.8663C9.93706 13.86 9.92327 13.8508 9.91167 13.8392L9.91147 13.839L3.66147 7.58898C3.63796 7.56547 3.62476 7.53359 3.62476 7.50035C3.62476 7.4671 3.63796 7.43522 3.66147 7.41171C3.68498 7.38821 3.71686 7.375 3.7501 7.375C3.78334 7.375 3.81521 7.3882 3.83871 7.41169C3.83872 7.4117 3.83873 7.41171 3.83874 7.41171L9.64653 13.2203L10.0001 13.5739L10.3537 13.2203L16.1615 7.41171C16.1615 7.4117 16.1615 7.4117 16.1615 7.41169C16.1731 7.40006 16.1869 7.39084 16.2021 7.38454C16.2173 7.37824 16.2336 7.375 16.2501 7.375C16.2666 7.375 16.2829 7.37824 16.2981 7.38454C16.3133 7.39084 16.3271 7.40007 16.3387 7.41171L16.6923 7.05816L16.3387 7.41171C16.3504 7.42335 16.3596 7.43717 16.3659 7.45238C16.3722 7.46759 16.3755 7.48389 16.3755 7.50035C16.3755 7.5168 16.3722 7.5331 16.3659 7.54832C16.3596 7.56353 16.3504 7.57734 16.3387 7.58898L16.6923 7.94254L16.3387 7.58898L10.0887 13.839Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/CaretDown.4b3894dbbdc52cbebdca710c82ebb86d.svg";
export { ForwardRef as ReactComponent };